module.exports = "<div ng-if=\"$ctrl.rmBindHtml\" ng-bind-html=\"$ctrl.text\" ng-class=\"{ collapsed: $ctrl.isCollapsed, expand: !$ctrl.isCollapsed }\">\n</div>\n<div ng-if=\"!$ctrl.rmBindHtml\" class=\"prewrap\" ng-class=\"{ collapsed: $ctrl.isCollapsed, expand: !$ctrl.isCollapsed }\">{{\n    $ctrl.text }}\n</div>\n<a class=\"readMoreLessLinks\" ng-if=\"$ctrl.isCollapsible\" ng-class=\"$ctrl.linkClass\" ng-click=\"$ctrl.isCollapsed = !$ctrl.isCollapsed\">{{\n    $ctrl.isCollapsed ? $ctrl.moreText : $ctrl.lessText }}</a>";


//////////////////
// WEBPACK FOOTER
// ./modules/shared/directives/readMore/readMore.template.html
// module id = 769
// module chunks = 0